import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose"; // @flow

import React from 'react';
/*::
import type { Node } from 'react';

export type IconProps = {|
  color?: string,
  width?: number,
  height?: number,
|}
*/

var WDZ = 50;
var HGT = 50;
var WTH = WDZ / HGT;
var HTW = HGT / WDZ;

var Close = function Close(_ref
/*: $Rest<IconProps, any> */
) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#1B4473' : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? WDZ / 10 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? HGT / 10 : _ref$height,
      rest = _objectWithoutPropertiesLoose(_ref, ["color", "width", "height"]);

  var w = width * 10 === WDZ ? height * WTH : width;
  var h = height * 10 === HGT ? width * HTW : height;
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 " + WDZ + " " + HGT,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      width: w + "rem",
      height: h + "rem"
    }
  }, rest), /*#__PURE__*/React.createElement("path", {
    d: "M50 2.27244L47.7276 0L25 22.7276L2.27244 0L0 2.27244L22.7276 25L0 47.7276L2.27244 50L25 27.2724L47.7276 50L50 47.7276L27.2724 25L50 2.27244Z" // eslint-disable-line max-len
    ,
    fill: color
  }));
};

export default Close;